import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";

const Return = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto my-10 max-w-container text-[14px] leading-10">
        <p className="mb-10 text-[20px] uppercase">RETURNS & EXCHANGES</p>
        <p>
          We accept returns within 30 days of delivery for items that are new
          and unused. Please return your items in their original packaging with
          the original barcode sticker for each item. Returns that arrive
          damaged, with missing parts, or not in original condition may be
          declined.
        </p>
        <p>
          Orders covered by Return Guard (Package Protection & Free Returns)
          receive a free return label and a full product refund.
        </p>
        <p>
          For orders not covered by Return Guard, returns to the original
          payment method are subject to a $7 shipping and restocking fee,
          deducted from your refund. Returns for store credit have no restocking
          fee.
        </p>
        <p>RETURN & EXCHANGE PROCESS</p>
        <p>
          Before getting started, have your order number and original email
          address ready. You can find your order number in your confirmation
          email.
        </p>
        <p>
          Follow the steps in our return portal to receive your return
          authorization and prepaid return label.
        </p>
        <p>
          After your return request is approved, you will receive a prepaid
          return shipping label and return instructions by email.
        </p>
        <p>
          Pack your items securely, then take them to the nearest eligible
          carrier location listed in your return instructions and present the
          applicable barcode or shipping label
        </p>
        <p>REFUNDS</p>
        <p>
          Once the returned items arrive at our warehouse, they will be
          inspected. If approved, a refund will be issued to your original
          payment method or as store credit, depending on your selection. Please
          allow 1–2 weeks for your bank or credit card provider to post the
          refund to your account. If you do not see the funds after that time,
          please contact your bank or card provider first. If they are unable to
          assist, contact us at x@Elvorloy.com.
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Return;
